export const SET_FILTERS = 'SET_FILTERS';

export const setFilters = (filter) => {
  return {
    type: SET_FILTERS,
    payload: filter,
  };
};
